import angular from 'angular';

/**
 * @ngdoc overview
 * @name dataManagementModule.dataManagementUsersServices
 * @description
 * dataManagementModule.dataManagementUsersServices
 * Module for managing the services of: users. For $http requests, API calls.
 */
const dataManagementUsersServices = angular.module('dataManagementModule.dataManagementUsersServices', []);

/**
 * @ngdoc interface
 * @name dataManagementModule.dataManagementUsersServices.interface:User
 * @description
 * Service for handling Users.
 */
dataManagementUsersServices.factory('DataManagementUser', ['DataManagementUserAPI', (DataManagementUserAPI) => {
    'use strict';
    return {
        getList: (params) => {
            return DataManagementUserAPI.getAllAppUsers(params)
                .then((response) => {
                    return response.data;
                });
        },
        get: (userId) => {
            return DataManagementUserAPI.getUserInfo(userId);
        },
        save: (data) => {
            return DataManagementUserAPI.saveUserInfo(data);
        },
        search: (appId, text, users) => {
            return DataManagementUserAPI.search(appId, text, users);
        },
        remove: (userId, appId) => {
            return DataManagementUserAPI.removeUser(userId, appId);
        },
        getAttributes: (appId) => {
            return DataManagementUserAPI.getAttributes(appId);
        }
    };
}]);

/**
 * @ngdoc interface
 * @name dataManagementModule.dataManagementUsersServices.interface:UserAPI
 * @description
 * Service for handling API connections for: Users.
 */
dataManagementUsersServices.service('DataManagementUserAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/app/users-www/`;

    this.getAllAppUsers = (params) => {
        return $http.get(`${API_URL}get/all`, {params: AppsoupAPI.getTableParams(params)});
    };

    this.getUserInfo = (userId) => {
        return $http.get(`${API_URL}get/by-id/${userId}`);
    };

    this.saveUserInfo = (data) => {
        return $http.put(`${API_URL}${data.id}`, data);
    };

    this.search = (text) => {
        return $http.get(`${API_URL}search-users/${text}`);
    };

    this.removeUser = (userId) => {
        return $http.delete(`${API_URL}delete/${userId}`);
    };

    this.getAttributes = (appId) => {
        return $http.get(`${API_URL}attributes/`, {params: {application_id: appId}});
    };
}]);

export default dataManagementUsersServices;
